import { render, staticRenderFns } from "./PartnershipPostList.vue?vue&type=template&id=707d55cb&scoped=true&"
import script from "./PartnershipPostList.vue?vue&type=script&lang=js&"
export * from "./PartnershipPostList.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipPostList.vue?vue&type=style&index=0&id=707d55cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d55cb",
  null
  
)

export default component.exports